"use strict";

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.starts-with");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBuilder = getBuilder;
exports.clearAll = clearAll;
exports.clearNonPersistent = clearNonPersistent;

var _storagebuilder = _interopRequireDefault(require("./storagebuilder"));

var _scopedstorage = _interopRequireDefault(require("./scopedstorage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBuilder(appId) {
  return new _storagebuilder.default(appId);
}

function clearStorage(storage, pred) {
  Object.keys(storage).filter(function (k) {
    return pred ? pred(k) : true;
  }).map(storage.removeItem.bind(storage));
}

function clearAll() {
  var storages = [window.sessionStorage, window.localStorage];
  storages.map(function (s) {
    return clearStorage(s);
  });
}

function clearNonPersistent() {
  var storages = [window.sessionStorage, window.localStorage];
  storages.map(function (s) {
    return clearStorage(s, function (k) {
      return !k.startsWith(_scopedstorage.default.GLOBAL_SCOPE_PERSISTENT);
    });
  });
}
//# sourceMappingURL=index.js.map